export default "__VITE_ASSET__DvA0zTYD__"